import yowsjs from '@yola/yowsjs';
import wsServiceClient from '@yola/ws-service-client';
import config from 'src/js/modules/config';
import yowsClient from '../yows-client';
import serviceClient from '../service-client';

const clientLoader = () => (next) => (action) => {
  switch (action.type) {
    case config.actionTypes.SET_SERVICE_CONFIG: {
      const configData = {
        config: {
          service: { ...action.payload.configData },
        },
      };
      const apiUrl = config.selectors.getApiUrl(configData);
      yowsClient.set(yowsjs.initWith(apiUrl));
      serviceClient.set(wsServiceClient.initWith(apiUrl));
      next(action);
      break;
    }
    default: {
      next(action);
    }
  }
};

export default clientLoader;
